// 组件对象，大写
import fMSuperForProductSearchModal from './fMSuperForProductSearchModal.vue'
export default fMSuperForProductSearchModal
